require('./brokerETFBuyView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const trim = require('lodash/string/trim');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKBadge = require('components/commons/OKBadge/OKBadge');

// @ components
const { EtfLegalConfirmation } = require('components/contactCenter/brokerLegalConfirmation/etfLegalConfirmation/etfLegalConfirmation');
const BrokerETFsHeader = require('components/broker/brokerProductHeaders/brokerETFsHeader/brokerETFsHeader');
const { BrokerETFBuyStep1 } = require('components/broker/brokerETFBuy/brokerETFBuyStep1/brokerETFBuyStep1');
const { BrokerETFBuyStep2 } = require('components/broker/brokerETFBuy/brokerETFBuyStep2/brokerETFBuyStep2');
const BrokerETFBuySuccess = require('components/broker/brokerETFBuy/brokerETFBuySuccess/brokerETFBuySuccess');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');
const { BrokerMiFIDBehavior } = require('mifid/components/brokerMiFIDBehavior/brokerMiFIDBehavior');
const WebappRender = require('components/conditionalRender/webappRender');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

// @ actions
const BrokerETFBuyActions = require('actions/brokerETFBuy');
const ProductFileActions = require('actions/brokerGetProductFile.js');
const ProductETFsFileActions = require('actions/brokerETFsProduct');
const brokerProductsPossessionsActions = require('actions/brokerProductsPossessions');
const BrokerConvenienceMiFIDTestAction = require('mifid/actions/brokerConvenienceMiFIDTest');
const BrokerOpenTraderActions = require('actions/brokerOpenTrader');
const BlockedAccountsActions = require('actions/blockedAccounts')
const BrokerMyInvestmentsActions = require('actions/brokerMyInvestments');
const CollectivesCommissionsInfoAction = require('actions/collectivesCommissions');

// @ constants
const {
    FIRST_STEP,
    SECOND_STEP,
    HIRE_VALUES_CONTRACT_URL,
    MYPROFILE_BROKER_EXPLORE_URL,
    MYPROFILE_BROKER_URL,
    BROKER_CONVENIENCE_MIFID_TEST_ETF_ID,
    BROKER_CONVENIENCE_MIFID_TEST_ETF_INT_ID,
    BROKER_CONVENIENCE_MIFID_ETF,
    BROKER_CONVENIENCE_MIFID_ETF_BUY,
    BROKER_MIFID_VERSION_2,
    COLLECTIVE_ETF_BUY,
    BROKER_BUY_SCREEN,
    BROKER_INFO_SCREEN
} = require('constants/index');
const SELECTED_VALUES = require("constants/contactCenter/brokerLegalConfirmationSelectedValues");

const { OPENTRADER } = require('constants/flagBasedFeatures');
// @utils
const { scrollToTop } = require('commonsUtilities/scrollUtils');

class BrokerETFBuyView extends React.Component {
    constructor(props) {
        super(props);
        this.getProductDetails = this.getProductDetails.bind(this);
        this.state = {
            selectedLegalConfirmationValue: SELECTED_VALUES.EMPTY,
        };
        this.handleLegalYesNoOptionChange = this.handleLegalYesNoOptionChange.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    componentWillMount() {
        const {
            immStocksContracts,
            history,
        } = this.props;
        if (immStocksContracts.isEmpty()) {
            history.push(HIRE_VALUES_CONTRACT_URL);
        }
    }

    componentDidMount() {
        const { history, immProfile, immBrokerConvenienceMiFIDTest } = this.props;
        this.getProductDetails();
        this.handleMifid(this.props);
        this.props.fetchMyInvestments();
        this.props.fetchOpenTraderLink();
        scrollToTop();

        if (immProfile.get("isCollective")) {
            this.props.getCollectivesCommissionsInfo(COLLECTIVE_ETF_BUY, history);
        }
    }

    componentWillReceiveProps(nextProps) {
        this.handleMifid(nextProps);
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.resetProduct();
        this.props.resetBlockedAccounts();
    }

    handleLegalYesNoOptionChange(value) {
        this.setState({
            ...this.state,
            selectedLegalConfirmationValue: value,
        });
    }

    onCancel() {
        this.props.history.push(MYPROFILE_BROKER_URL);
    }

    getBreadcrumbData(productFile, isin, iso) {
        return [
            {
                text: formatText("breadcrumb-brokerInvestments"),
                url: MYPROFILE_BROKER_URL,
            },
            {
                text: formatText("breadcrumb-brokerAdvancedSearch"),
                url: MYPROFILE_BROKER_EXPLORE_URL,
            },
            {
                text: productFile.get("companyName"),
                url: `/myprofile/broker/etfsProductFile/${isin}/${iso}`,
            },
            {
                text: formatText("breadcrumb-brokerStocksBuy"),
                url: "",
            },
        ];
    }

    getProductDetails() {
        const {
            getProductDetails,
            getETFsProductByIsin,
            getProductPossessions,
            immBrokerConvenienceMiFIDTest,
            getDFI,
            match: { params: { isin, iso } }
        } = this.props;
        const screenType = immBrokerConvenienceMiFIDTest.get('resultDisplayed')
            ? BROKER_BUY_SCREEN
            : BROKER_INFO_SCREEN;
        getProductDetails(isin, iso, screenType);
        getETFsProductByIsin(isin, iso, BROKER_INFO_SCREEN);
        getProductPossessions(isin, iso);
        getDFI(isin);
        this.props.getETFsCatalogueDetails(isin);
    }

    buildSuccessful() {
        const { immETFBuy, productFile, immStocksContracts } = this.props;

        return (
            <div className="broker-etf-buy-view__success col-lg-12">
                <BrokerETFBuySuccess
                    productFile={productFile}
                    immETFBuy={immETFBuy}
                    immStocksContracts={immStocksContracts}
                />
            </div>
        );
    }

    buildWizard() {
        const {
            setVisibleStep,
            setWillCancel,
            finish,
            validateStep,
            immETFBuy,
            productFile,
            immStocksContracts,
            immProfile,
            immETFProduct,
            immCollectivesCommissions,
            getDFI,
            toggleDocumentsCheckbox,
            toggleRiskCheckbox,
            resetCheckbox,
            flagBasedFeatures,
            fetchExtantCostETFBuy
        } = this.props;
        const productIsin = productFile.get('isinCode');
        const productIso = productFile.get('micCode');
        const productCurrency = productFile.get('currency');
        const immSteps = immETFBuy.get('steps');
        const visibleStep = immETFBuy.get('visibleStep');
        const catalogueLoading = immETFProduct.get('isFetchingETFCatalogue');
        const firstStepLoading = immETFBuy.getIn(['steps', FIRST_STEP, 'loading']);
        const secondStepLoading = immETFBuy.getIn(['steps', SECOND_STEP, 'loading']);
        const isCryptoETF = immETFProduct.get('isCryptoETF');
        const actions = {
            setVisibleStep,
            finish,
            validateStep,
            cancel: this.onCancel,
            setWillCancel,
        };
        const productPrice = productFile.get("buyPrice");
        const isCollectiveUser = !!immProfile.get("isCollective");
        const etfCommisionsLinkUrl = formatText("broker-product_buy_sale_flow_see_fees_link");
        let linksData = [];
        const titleHeaderMenuWizard = visibleStep === 1 ? formatText("broker-etfBuyViewWizardTitle") : formatText("broker-etfBuyViewWizardTitleStepTwo");

        const headerMenuData = {
            title: titleHeaderMenuWizard,
            linksData,
        };

        if (isCollectiveUser) {
            const collectivesUrl = immCollectivesCommissions.get("url");
            headerMenuData.extraContent = (
                <OKBadge
                    toUrl={collectivesUrl}
                    target={"_blank"}
                    name={formatText(
                        "broker-etfsBuyWizardBadgeLabel"
                    ).toUpperCase()}
                />
            );
        } else {
            headerMenuData.linksData.push({
                label: formatText("broker-etfBuyViewWizardFirstLinkLabel"),
                href: etfCommisionsLinkUrl,
                hasTooltip: false,
                target: "_blank",
            });
        }
        const blockWizardCC = !(this.state.selectedLegalConfirmationValue === 'YES');
        const overlay = __CONTACT_CENTER__ && blockWizardCC
            ? <div className="broker-etf-buy-view__wizard-overlay" />
            : null;
        const step2 = immETFBuy.get('steps').get(SECOND_STEP);
        const riskCheckboxValue = step2.get('riskCheckbox')
        const documentsCheckboxValue = step2.get('documentsCheckbox')
        const finalButtonIsDisabled = !(__CONTACT_CENTER__ || (documentsCheckboxValue && (riskCheckboxValue || !isCryptoETF)));
        return (
            <div className="broker-etf-buy-view__wizard-container">
                {overlay}
                <Wizard
                    wizardClass={"broker-etf-buy-view__wizard"}
                    actions={actions}
                    immSteps={immSteps}
                    stepsAmount={immSteps.size}
                    visibleStep={visibleStep}
                    hasHeaderMenu={true}
                    headerMenuData={headerMenuData}
                >
                    <WizardStep position="first" cancelButton={true} isLoading={firstStepLoading || catalogueLoading}>
                        <BrokerETFBuyStep1
                            productIsin={productIsin}
                            productIso={productIso}
                            productCurrency={productCurrency}
                            productPrice={productPrice}
                            immETFBuy={immETFBuy}
                        />
                    </WizardStep>
                    <WizardStep
                        position="last"
                        immFinalButton="broker-etfBuyViewFinishButtonLabel"
                        cancelButton={true}
                        isLoading={secondStepLoading}
                        finalButtonDisabled={finalButtonIsDisabled}
                    >
                        <BrokerETFBuyStep2
                            productFile={productFile}
                            immETFBuy={immETFBuy}
                            immFeatureFlags={flagBasedFeatures}
                            immStocksContracts={immStocksContracts}
                            handleTermsChecked={this.props.mifidClauseChanged}
                            getDFI={getDFI}
                            toggleRiskCheckbox={toggleRiskCheckbox}
                            toggleDocumentsCheckbox={toggleDocumentsCheckbox}
                            resetCheckbox={resetCheckbox}
                            isCryptoETF={isCryptoETF}
                            fetchExtantCostETFBuy={fetchExtantCostETFBuy}
                        />
                    </WizardStep>
                </Wizard>
            </div>
        );
    }

    handleMifid(/*props*/) {
        /*if (props.immStocksContracts.isEmpty()) {
            return;
        }

        const productName = (props.productFile.get('companyName') || '').trim();
        const isComplex = props.productFile.get('isComplex');

        if (!productName) {
            return;
        }

        const productId = isComplex ? BROKER_CONVENIENCE_MIFID_TEST_ETF_INT_ID : BROKER_CONVENIENCE_MIFID_TEST_ETF_ID;

        const isin = props.params.isin;
        const iso = props.params.iso;

        const productUrl = `/myprofile/broker/etfsProductFile/${isin}/${iso}`;
        const continuationUrl = `/myprofile/broker/etfsBuy/${isin}/${iso}`;

        const hideAlreadyPerformTestResult = !isComplex;

        props.onStartConvenienceMiFIDTest(productName, productUrl, productId, continuationUrl, {
            hideAlreadyPerformTestResult,
            productType: BROKER_CONVENIENCE_MIFID_ETF,
        });*/
    }

    handleOnClick = () => {
        this.props.history.push(MYPROFILE_BROKER_EXPLORE_URL);
    };

    isAbleToContinue() {
        return (
            this.state.selectedLegalConfirmationValue === SELECTED_VALUES.YES
        );
    }

    buildNextButtonWrapperLegalConfirmation(isin) {
        return (
            <EtfLegalConfirmation
                onYesNoOptionChange={this.handleLegalYesNoOptionChange}
                selectedLegalConfirmationValue={
                    this.state.selectedLegalConfirmationValue
                }
                isin={isin}
            />
        );
    }

    render() {
        const {
            etfsProduct,
            immETFBuy,
            immETFProduct,
            flagBasedFeatures,
            immMyInvestments,
            immOpenTrader,
            match: { params },
            productFile,
        } = this.props;
        const mappingBreadcrumb = this.getBreadcrumbData(
            productFile,
            params.isin,
            params.iso
        );
        const productName = trim(this.props.productFile.get("companyName"));
        const isin = this.props.match.params.isin;
        const iso = this.props.match.params.iso;
        const productUrl = `/myprofile/broker/etfsProductFile/${isin}/${iso}`;
        const continuationUrl = `/myprofile/broker/etfsBuy/${isin}/${iso}`;
        const isComplex = this.props.productFile.get("isComplex");
        const isCryptoETF = immETFProduct.get('isCryptoETF');
        const productId = isComplex
            ? BROKER_CONVENIENCE_MIFID_TEST_ETF_INT_ID
            : BROKER_CONVENIENCE_MIFID_TEST_ETF_ID;
        const subtitle = isCryptoETF ? (
            <FormattedText value={"broker-etfsCriptoSummaryProductName"} />
        ) : (
            <FormattedText value={"broker-etfSummaryProductName"} />
        );
        const mifidOptions = {
            hideAlreadyPerformTestResult: !isComplex,
            productType: BROKER_CONVENIENCE_MIFID_ETF,
            operationType: BROKER_CONVENIENCE_MIFID_ETF_BUY,
        };
        let contractBoxContent;

        if (immETFBuy.get("submitSuccessful")) {
            contractBoxContent = this.buildSuccessful();
        } else if (productFile.get("isinCode")) {
            contractBoxContent = this.buildWizard();
        }
        const visibleStep = immETFBuy.get('visibleStep');
        const legalConfirmation =
            __CONTACT_CENTER__ && visibleStep !== 2
                ? this.buildNextButtonWrapperLegalConfirmation(isin)
                : null;
        return (
            <BrokerMiFIDBehavior
                mifidVersion={BROKER_MIFID_VERSION_2}
                productName={productName}
                productUrl={productUrl}
                continuationUrl={continuationUrl}
                productIsinId={isin}
                productMarketId={iso}
                productMifidId={productId}
                mifidOptions={mifidOptions}
            >
                <div className="broker-etf-buy-view">
                    <OKCover size="medium" section="broker">
                        <BrokerTruncatedBreadcrumb
                            titleKey="broker-etfBuyViewTitle"
                            breadcrumbConfig={mappingBreadcrumb}
                            subtitleLeft={subtitle}
                            className="broker-etf-buy-view__header"
                        >
                            <OKButton
                                inverse={true}
                                modifier="ghost"
                                onClick={() => this.handleOnClick()}
                            >
                                <FormattedText
                                    format="firstUppercase"
                                    value="broker-goToAdvancedSearch"
                                />
                            </OKButton>
                            <WebappRender>
                                <FeatureTogglingRender
                                    notAllowedProductKey={OPENTRADER}
                                >
                                    <OKButton
                                        inverse={true}
                                        modifier="primary"
                                        to={immOpenTrader.get("openTraderLink")}
                                    >
                                        <FormattedText
                                            format="firstUppercase"
                                            value="broker-openTraderLabel"
                                        />
                                    </OKButton>
                                </FeatureTogglingRender>
                            </WebappRender>
                        </BrokerTruncatedBreadcrumb>
                    </OKCover>
                    <section className="broker-etf-buy-view__body">
                        <BrokerETFsHeader
                            productFile={productFile}
                            immMyInvestments={immMyInvestments}
                            handleUpdate={this.getProductDetails}
                            noBottomButtons={true}
                            immFlagBasedFeatures={flagBasedFeatures}
                            etfsProduct={etfsProduct}
                        />
                        {legalConfirmation}
                        <div className="broker-etf-buy-view__wizard">
                            {contractBoxContent}
                        </div>
                    </section>
                </div>
            </BrokerMiFIDBehavior>
        );
    }
}

BrokerETFBuyView.propTypes = {
    etfsProduct: PropTypes.object,
    fetchExtantCostETFBuy: PropTypes.func.isRequired,
    fetchMyInvestments: PropTypes.func.isRequired,
    fetchOpenTraderLink: PropTypes.func.isRequired,
    finish: PropTypes.func,
    flagBasedFeatures: PropTypes.object.isRequired,
    getCollectivesCommissionsInfo: PropTypes.func,
    getDFI: PropTypes.func,
    getETFsCatalogueDetails: PropTypes.func.isRequired,
    getETFsProductByIsin: PropTypes.func,
    getProductDetails: PropTypes.func,
    getProductPossessions: PropTypes.func,
    history: PropTypes.object.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    immCollectivesCommissions: PropTypes.object.isRequired,
    immETFBuy: PropTypes.object,
    immETFProduct: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    immOpenTrader: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    immStocksContracts: PropTypes.object,
    immVariables: PropTypes.object.isRequired,
    match: PropTypes.object,
    mifidClauseChanged: PropTypes.func,
    onStartConvenienceMiFIDTest: PropTypes.func.isRequired,
    productFile: PropTypes.object,
    reset: PropTypes.func,
    resetBlockedAccounts: PropTypes.func,
    resetCheckbox: PropTypes.func,
    resetProduct: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func,
    setWillCancel: PropTypes.func,
    toggleDocumentsCheckbox: PropTypes.func,
    toggleRiskCheckbox: PropTypes.func,
    validateStep: PropTypes.func,
};

module.exports.constructor = BrokerETFBuyView;
module.exports.BrokerETFBuyView = connect(
    (state) => ({
        etfsProduct: state.brokerETFsProduct,
        flagBasedFeatures: state.flagBasedFeatures,
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immCollectivesCommissions: state.collectivesCommissions,
        immETFBuy: state.brokerETFBuy,
        immETFProduct: state.brokerETFsProduct,
        immMyInvestments: state.brokerMyInvestments,
        immOpenTrader: state.brokerOpenTrader,
        immProfile: state.profile,
        immStocksContracts: state.brokerStocksContract,
        immVariables: state.globalVariables.get("variables"),
        productFile: state.brokerProductFile,
    }),
    {
        reset: BrokerETFBuyActions.reset,
        resetBlockedAccounts: BlockedAccountsActions.resetBlockedAccounts,
        setVisibleStep: BrokerETFBuyActions.setVisibleStep,
        setWillCancel: BrokerETFBuyActions.setWillCancel,
        finish: BrokerETFBuyActions.finish,
        validateStep: BrokerETFBuyActions.validateStep,
        getProductDetails: ProductETFsFileActions.getProductFile,
        getETFsCatalogueDetails: ProductETFsFileActions.getETFsCatalogueDetails,
        getProductPossessions: brokerProductsPossessionsActions.getProductPossessions,
        resetProduct: ProductFileActions.reset,
        mifidClauseChanged: BrokerETFBuyActions.mifidClauseChanged,
        onStartConvenienceMiFIDTest: BrokerConvenienceMiFIDTestAction.start,
        fetchOpenTraderLink: BrokerOpenTraderActions.fetchLink,
        fetchMyInvestments: BrokerMyInvestmentsActions.fetchMyInvestments,
        getCollectivesCommissionsInfo: CollectivesCommissionsInfoAction.getCollectivesCommissionsInfo,
        getDFI: BrokerETFBuyActions.getDFI,
        toggleDocumentsCheckbox: BrokerETFBuyActions.toggleDocumentsCheckbox,
        toggleRiskCheckbox: BrokerETFBuyActions.toggleRiskCheckbox,
        resetCheckbox: BrokerETFBuyActions.resetCheckbox,
        getETFsProductByIsin: ProductETFsFileActions.getETFsRatingRiskTab,
        fetchExtantCostETFBuy: BrokerETFBuyActions.getExtantCostBuyETF,

    }
)(withRouter(BrokerETFBuyView));
